// Deterministic "rule-candidate stem" for a class name -- DISPLAY / GROUPING ONLY.
//
// Class names embed schedule noise (Phase 3 measured: 93% carry a time, 90% a day), e.g.
// "Micro (4-5 years) Saturday 11am". Stripping the day-of-week and clock-time tokens groups the
// schedule variants of one real class type together, so recurring naming patterns surface above
// one-off anomalies in the Missing Levels insights panel.
//
// SCOPE / SAFETY: this NEVER affects matching, storage, or how a class name is displayed in the grid
// -- it only decides how the read-only insights panel *groups* rows. It is deliberately CONSERVATIVE
// and explicit: it removes only day-of-week words and clock times. It does NOT strip room/section
// letters (" A", " D") or coach names ("-Theresa"), because those risk removing meaningful tokens;
// that means some variants won't fully collapse, which is acceptable for a display aid. No fuzzy
// logic of any kind.

// Day-of-week words and common abbreviations, plus an OPTIONAL trailing abbreviation period ("Fri.",
// "Mon.") -- so removing the day never leaves an orphan "." on the stem (some franchises, e.g. All
// American, write days as "Fri."). The `\b` still anchors the word to keep it from matching inside
// other words (e.g. "sun" never inside "Sunshine"; "sat" never inside "Saturday" partially); the
// `\.?` after the boundary consumes only the abbreviation's own trailing dot, never meaningful
// terminal punctuation elsewhere (e.g. a closing ")" survives).
// EXPORTED so the rule-seed transform (classNamePattern) detects exactly the same removable tokens.
// The two transforms must never drift: the seed is derived from the same schedule vocabulary this
// grouping key strips. Consumers must build their own RegExp from `.source` rather than calling
// .exec() on these objects -- they carry the /g flag, so a shared lastIndex would leak across calls.
export const DAY = /\b(?:monday|mon|tuesday|tues|tue|wednesday|weds|wed|thursday|thurs|thur|thu|thr|friday|fri|saturday|sat|sunday|sun)\b\.?/gi;

// Clock times: "10:30am" / "4:00 pm" / "5:30p" / "11am" / "4 pm" / bare "10:30".
export const TIME = /\b\d{1,2}:\d{2}\s*[ap]\.?\s?m?\.?|\b\d{1,2}\s*[ap]\.?\s?m\.?\b|\b\d{1,2}:\d{2}\b/gi;

export function classNameStem(name) {
  if (name === null || name === undefined) return '';
  const original = String(name).trim();
  let s = ' ' + original + ' ';
  s = s.replace(DAY, ' ').replace(TIME, ' ');
  s = s.replace(/\s+/g, ' ').trim();
  // Never collapse a name entirely to empty (e.g. a name that is only a schedule) -- keep the original.
  return s.length ? s : original;
}
